// src/api/services/paymentService.ts
import { PlaidLinkOnSuccessMetadata } from "react-plaid-link";
import api from "../axios";

export interface PaymentInstitutionDto {
  id: number;
  bankName: string;
  logoUrl: string;
  url: string;
}

export interface PaymentAccountDto {
  id: number;
  bankAccountId: string;
  mask: string;
  institution: PaymentInstitutionDto;
}

// 1) List existing linked bank accounts
export function getPaymentAccounts() {
  return api.get<PaymentAccountDto[]>("/payments/accounts");
}

// 2) Fetch a Plaid link token for "connect bank"
export function getPaymentLinkToken() {
  return api.get<{ link_token: string }>("/payments/link-token");
}

export function exchangePublicToken(
  publicToken: string,
  metadata: PlaidLinkOnSuccessMetadata,
  // Required for the SDA + renewal flow — the backend rejects without
  // explicit acceptance. Defaulted to `false` so the typechecker doesn't
  // break legacy callers (e.g. financial-info onboarding) that don't yet
  // show a disclosure step; those calls will fail at runtime with a 400
  // until they wire one in.
  mandateAccepted: boolean = false,
) {
  return api.post("/payments/exchange", {
    publicToken,
    metadata,
    mandateAccepted,
  });
}

// 4) Remove a payment account
export function removePaymentAccount(accountId: number) {
  return api.delete(`/payments/accounts/${accountId}`);
}